'use strict';

var App = require('app');
var AppState = require('app_state');
var Consts = require('consts');
var I18N = require('utils/i18n');
var Misc = require('utils/misc');
var Notification = require('utils/notification');
var OOP = require('utils/oop');
var OverviewConfigureDialog = require('components/devices/views/gateway/overview_configure_dialog_view');

var channelReq = App.requestChannel(5);
var refreshDelayed = Misc.delayedExec(500);

var OverviewContentView = OOP.extend(
    Marionette.ItemView,
    {
        template: require('components/devices/templates/gateway/overview_content'),
        setPermission: function (permissions) {},

        onShow: function () {
            this.options.pagination.initEvents();
        },

        serializeData: function () {
            return this.options;
        },
    },
    'OverviewView'
);

module.exports = OOP.extend(Marionette.LayoutView, {
    ui: {
        deviceFilter: '#overview-device-filter',
        valueFilter: '#overview-value-filter',
    },

    events: {
        'keyup #overview-device-filter': function () {
            this.data.page = 1;
            this.updateContent();
        },
        'keyup #overview-value-filter': function () {
            this.data.page = 1;
            this.updateContent();
        },
    },

    regions: {
        content: '#overviewContent',
    },

    initialize: function (options) {
        this.base.initialize(options);
        this.data = {
            allDevices: [],
            devices: [],
            message: '',
            deviceFilter: '',
            valueFilter: '',
            page: 1,
        };
    },

    template: require('components/devices/templates/gateway/overview'),
    setPermission: function (permissions) {},
    serializeData: function () {
        return {
            message: this.data.message,
            devices: this.data.allDevices,
            deviceFilter: this.data.deviceFilter,
            valueFilter: this.data.valueFilter,
            selectedDevicesCount: (this.data.devices && this.data.devices.length) || '',
            devicesCount: this.data.allDevices.length,
        };
    },

    configure: function () {
        var self = this;

        $.when(
            App.request('devices:overview:values:load', this.model.id),
            App.request('device:list', {
                filterParams: { connectionDeviceID: this.model.id },
            })
        ).done(function (selectedValues, devices) {
            if (!selectedValues || !devices.items) {
                Notification.show('error', I18N.TR('Fehler'), I18N.TR('Die Auswahl konnte nicht geladen werden'));
                return;
            }

            var deviceItems = devices.items.toJSON();
            App.showModal(
                new OverviewConfigureDialog({
                    deviceName: self.model.get('name'),
                    devices: deviceItems,
                    selectedValues: selectedValues.values || [],
                    cb: function (values) {
                        // save selected values
                        $.when(App.request('devices:overview:values:save', self.model.id, values)).done(function (ok) {
                            if (ok) {
                                self.reload(true);
                            } else {
                                Notification.show(
                                    'error',
                                    I18N.TR('Fehler'),
                                    I18N.TR('Die Auswahl konnte nicht gespeichert werden')
                                );
                            }
                        });
                    },
                }),
                'modal-lg'
            );
        });
    },

    reload: function (clear) {
        var self = this;
        if (clear) {
            this.data.devices = undefined;
            this.render();
        }
        $.when(App.request('devices:connected', this.model.id)).done(function (deviceList) {
            if (deviceList === undefined) {
                self.data.message = Misc.errorMessageView(
                    'err',
                    I18N.TR('Die Geräteliste konnte nicht geladen werden')
                );
                self.render();
                return;
            }
            if (deviceList.length == 0) {
                self.data.message = self.createOverviewContentMessage(self.data.allDevices);
                self.render();
                return;
            }

            self.data.allDevices = deviceList;
            self.data.message = undefined;
            self.render();
            self.updateContent();
        });
    },

    buildContentView: function (devices, allDeviceCount) {
        var self = this;
        this.filterOverviewValues(devices, this.data.valueFilter);

        devices = Misc.selectWhere(devices, function (d) {
            return (d.displayData && d.displayData.length > 0) || !d.loaded;
        });

        this.showChildView(
            'content',
            new OverviewContentView({
                deviceCount: devices.length,
                allDeviceCount: allDeviceCount,
                valueFilter: this.data.valueFilter,
                devices: devices,
                message: this.createOverviewContentMessage(devices),
                pagination: this.createOverviewPagination(
                    this,
                    this.data.page,
                    this.data.allDevices,
                    this.data.deviceFilter,
                    function (page) {
                        self.data.page = page;
                        self.updateContent();
                    }
                ),
            })
        );
    },

    getAllDeviceCount: function () {
        return Misc.selectWhere(this.data.allDevices, function (item) {
            return !item.loaded || (item.allData && item.allData.length > 0);
        }).length;
    },

    updateContent: function () {
        var self = this;
        this.data.deviceFilter = this.ui.deviceFilter.val() || '';
        this.data.valueFilter = this.ui.valueFilter.val() || '';

        var devices = this.overviewFilter(
            this.data.allDevices,
            this.data.deviceFilter,
            this.data.page,
            AppState.getItemsPerPage()
        );

        this.loadOverviewValues(devices, this.data.allDevices, function () {
            self.buildContentView(devices, self.getAllDeviceCount());
        });

        this.buildContentView(devices, this.getAllDeviceCount());
    },

    onShow: function () {
        this.reload(true);
    },

    createOverviewContentMessage: function (devices) {
        if (devices.length == 0) {
            return Misc.infoMessageView('err_content', '', I18N.TR('Keine Geräte gefunden'));
        }
        return undefined;
    },

    filterOverviewValues: function (devices, filter) {
        devices.forEach(function (d) {
            if (d.allData) {
                d.displayData = Misc.selectWhere(d.allData, function (v) {
                    return v.name.toLowerCase().includes(filter.toLowerCase());
                });
            }
        });
    },

    createOverviewPagination: function (view, currentPage, devices, filter, gotoPage) {
        var filteredDevices = this.overviewFilterAll(devices, filter);
        return Misc.generatePagination({
            context: view,
            currentPage: currentPage,
            pageCount: Math.ceil(filteredDevices.length / AppState.getItemsPerPage()),
            onSetItemsPerPage: function (itemCount) {
                AppState.saveItemsPerPage(itemCount);
                gotoPage(1);
            },
            onGotoPage: gotoPage,
        });
    },

    overviewFilterAll: function (source, filter) {
        return Misc.selectWhere(source, function (a) {
            return a.name.toLowerCase().includes(filter.toLowerCase());
        });
    },

    overviewFilter: function (source, filter, page, itemsPerPage) {
        var items = this.overviewFilterAll(source, filter);
        var start = itemsPerPage * (page - 1);
        var devices = Misc.selectWhere(items, function (item, idx) {
            return idx >= start && idx < start + itemsPerPage;
        });

        return devices;
    },

    loadOverviewValues: function (devices, allDevices, updateFct) {
        allDevices.forEach(function (item) {
            var visible = devices.includes(item);
            item.stopped = !visible && (item.stopped || item.visible);
            item.visible = visible;

            if (item.visible && !item.loaded) {
                $.when(channelReq('devices:overview:values:get', item.id)).done(function (response) {
                    item.loaded = true;
                    if (response && response.length > 0) {
                        var deviceData = response[0];

                        item.allData = _.sortBy(
                            Misc.selectWhere(Object.keys(deviceData.data || []), undefined, function (key) {
                                var valueRec = Misc.getValueDisplayInfos(
                                    deviceData.data[key],
                                    key,
                                    deviceData.formatInfos[key].format,
                                    deviceData.formatInfos[key].unit,
                                    deviceData.formatInfos[key].display_unit || '',
                                    deviceData.formatInfos[key].is_unit_fixed || false
                                );
                                var r = {
                                    name: deviceData.formatInfos[key].name,
                                    unit: valueRec.unit,
                                    value: valueRec.value,
                                };
                                return r;
                            }),
                            function (a, b) {
                                return a.name.localeCompare(b.name);
                            }
                        );

                        item.displayData = item.allData;
                    } else {
                        item.allData = [];
                        item.displayData = [];
                    }

                    refreshDelayed(function () {
                        if (item.visible) {
                            updateFct();
                        }
                    });
                });
            }
        });
    },
});
